import { Box, Typography } from "@mui/material";
import { useFormatLocalDate } from "hooks/useFormatLocalDate";
import { useTenantTranslation } from "hooks/formatters";

interface TableHeaderProps {
  titlePrefix: string;
  subtitleText: string;
  selectedDate: Date | null;
  formatDateMonthly: boolean;
}

export const TableHeader = ({
  titlePrefix,
  subtitleText,
  selectedDate,
  formatDateMonthly,
}: TableHeaderProps) => {
  const { t } = useTenantTranslation();
  const formatMonthYear = useFormatLocalDate("monthYear", "UTC");
  const formatDate = useFormatLocalDate("date", "UTC");

  const formattedDate = selectedDate
    ? formatDateMonthly
      ? formatMonthYear(selectedDate)
      : formatDate(selectedDate)
    : t("allTimePeriod");

  return (
    <Box>
      <Typography variant="h5">{`${titlePrefix} ${formattedDate}`}</Typography>
      <Typography variant="body1">{subtitleText}</Typography>
    </Box>
  );
};
